import { Icon } from '@iconify/react';
import { useState, useEffect } from 'react';
import roundVpnKey from '@iconify/icons-ic/round-vpn-key';
import roundAccountBox from '@iconify/icons-ic/round-account-box';
import { useSnackbar } from 'notistack5';
// material
import { Container, Tab, Box, Tabs, Stack } from '@material-ui/core';
// redux
import { useDispatch } from '../../redux/store';
import { getCards, getProfile, getInvoices, getAddressBook, getNotifications } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import {
  SettingGeneral,
  SettingChangePassword,
  SettingSip
} from '../../components/_dashboard/setting/settings';
import useAuth from '../../hooks/useAuth';
import apiUser from '../../api/user';
import { useLocation } from 'react-router';
import queryString from 'query-string';
// ----------------------------------------------------------------------

export default function Settings({onClose}) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();

  const [userInfo, setUserInfo] = useState();
  const dispatch = useDispatch();
  const location = useLocation();
  const params=queryString.parse(location.search);
  const [currentTab, setCurrentTab] = useState(params['tab']==="setting_sip"?"setting_sip":"general");
  useEffect(() => {
    const get_user = async () => {
      try {
        const res = await apiUser.findone_user();
        setUserInfo(res.data.data[0]);
      } catch (error) {
        enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
      }
    }
    get_user();
  }, []);

  const ACCOUNT_TABS = [
    {
      value: 'general',
      nameTab: 'Cập nhật thông tin',
      icon: <Icon icon={roundAccountBox} width={20} height={20} />,
      component: <SettingGeneral userInfo={userInfo} onClose={onClose}/>
    },
    // {
    //   value: 'config_fields_data',
    //   nameTab:'Cấu hình trường dữ liệu',
    //   icon: <Icon icon={roundReceipt} width={20} height={20} />,
    //   component: <SettingFields />
    // },
    // {
    //   value: 'notifications',
    //   nameTab:'Cấu hình thông báo',
    //   icon: <Icon icon={bellFill} width={20} height={20} />,
    //   component: <SettingNotifications />
    // },
    // {
    //   value: 'social_links',
    //   nameTab:'Mạng xã hội',
    //   icon: <Icon icon={shareFill} width={20} height={20} />,
    //   component: <SettingSocialLinks />
    // },
    {
      value: 'change_password',
      nameTab: 'Thay đổi mật khẩu',
      icon: <Icon icon={roundVpnKey} width={20} height={20} />,
      component: <SettingChangePassword onClose={onClose}/>
    },
    // {
    //   value: 'setting_sip',
    //   nameTab: 'Cài đặt thông số SIP',
    //   icon: <Icon icon="material-symbols:dialer-sip-rounded" width={20} height={20} />,
    //   component: <SettingSip userInfo={userInfo} onClose={onClose}/>
    // }
  ];

  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Page title="Cập nhật thông tin | Voip24h">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading=""
          links={[
            { name: '' }
          ]}
        />

        <Stack spacing={5}>
          <Tabs
            value={currentTab}
            scrollButtons="auto"
            variant="scrollable"
            allowScrollButtonsMobile
            onChange={handleChangeTab}
          >
            {ACCOUNT_TABS.map((tab) => (
              <Tab disableRipple key={tab.value} label={tab.nameTab} icon={tab.icon} value={tab.value} />
            ))}
          </Tabs>

          {ACCOUNT_TABS.map((tab) => {
            const isMatched = tab.value === currentTab;
            return isMatched && <Box key={tab.value}>{tab.component}</Box>;
          })}
        </Stack>
      </Container>
    </Page>
  );
}
